/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Table,
  Select,
  Tooltip,
} from 'antd';
import { ShrinkOutlined } from '@ant-design/icons';
import queryString from 'query-string';
import Fullscreen from 'fullscreen-react';
import {
  notificationActions,
  shopDetailsActions,
} from 'store/actions';
import {
  ROLES,
  PAGES,
} from 'appconstants';
import { axiosAuthInstance } from 'api';
import { NOTIFICATION } from 'store/actionTypes';
import moment from 'moment';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import debounce from 'lodash.debounce';
import { useLocation } from 'react-router-dom';
import Loading from 'components/Loading';
import {
  SpText,
} from 'components/DesignKit';
import '../../styles/_tableOrderStatus.scss';
import expand from '../../assets/imgs/expand.svg';
import powered from '../../assets/imgs/powered.svg';
import timerImg from '../../assets/imgs/prepTime.svg';
// import prepTimer from '../../assets/imgs/prepTimer.svg';
// import ReadyTimer from '../../assets/imgs/readyTimer.svg';
// import uerStatus from '../../assets/imgs/userStatus.svg';
import statusBg from '../../assets/imgs/statusBg.svg';

const { Option } = Select;

type Props = {
  validator: boolean,
  shopData: Array,
  fetchShopDetails: Function,
  fetchShopOrderStatusDetails: Function,
  orderDetails: Array,
  sendFcmToken: Function,
  loading: boolean,
  setNotification: Function,
  selectedAccount: Object,
  totalElements: Number,
  role: Object,
  fetchAllShopDetails: Function,
  fetchFullfillDetails: Function,
  shopsList: Array,
  history: {
    push: Function,
  },
  totalPages: Number,
};

const firebaseConfig = {
  apiKey: 'AIzaSyB7XtYo08EXBb9e7CTX4QiPgFZNVn8pkVc',
  authDomain: 'swirepay-fe.firebaseapp.com',
  projectId: 'swirepay-fe',
  storageBucket: 'swirepay-fe.appspot.com',
  messagingSenderId: '436076744344',
  appId: '1:436076744344:web:a1ad170a26ae61562b0aed',
  measurementId: 'G-ZP7NX358P9',
};

const fapp = initializeApp(firebaseConfig);
const messaging = getMessaging(fapp);

const OrderStatusView = (props: Props) => {
  const location = useLocation();
  const {
    validator,
    shopData,
    orderDetails,
    fetchShopDetails,
    fetchShopOrderStatusDetails,
    sendFcmToken,
    loading,
    setNotification,
    history,
    selectedAccount,
    role,
    fetchAllShopDetails,
    fetchFullfillDetails,
    shopsList,
    totalElements,
    totalPages,
  } = props;
  const [messageRecevied, setMessageRecevied] = useState(false);
  const [firstTimeFetch, setFirstTimeFetch] = useState(true);
  const [internalShopGid, setInternalShopGid] = useState('');
  const [shopName, setShopName] = useState('');
  const [shopImage, setShopImage] = useState('');
  const email = localStorage.getItem('email');
  const kdsRole = localStorage.getItem('kdsRole');
  const [shopGid, setShopGid] = useState(kdsRole === ROLES.ASSOCIATE ? (shopData && shopData[0] && shopData[0].shop && shopData[0].shop.gid) : null);
  const kdsFilterTimeInMinutes = (kdsRole !== 'associate') ? (selectedAccount && selectedAccount.kdsFilterTimeInMinutes) : null;
  const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
  const newTime = kdsFilterTimeInMinutes ? moment().subtract((kdsFilterTimeInMinutes || 60), 'minutes').utc().format(MOMENT_FORMAT) : null;
  const debouncedfetchShopOrderStatusDetails = debounce(fetchShopOrderStatusDetails, 2000, { leading: true });
  const [isEnter, setIsEnter] = useState(false);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(60);
  const [preparingOrders, setPreparingOrders] = useState([]);
  const [preparingOrder, setPreparingOrder] = useState([]);
  const [pickupOrders, setPickupOrders] = useState([]);
  const [bannerText, setBannerText] = useState('');
  const [initialLoad, setInitialLoad] = useState(true);
  const [tableCount, setTableCount] = useState(null);

  const getData = (query) => {
    const parsed = queryString.parse(query);
    const currentPage = parsed.pageNum || 1;
    if (shopGid) {
      debouncedfetchShopOrderStatusDetails({
        currentPage,
        shopGid,
        newTime,
      });
    } else if (internalShopGid) {
      debouncedfetchShopOrderStatusDetails({
        currentPage,
        shopGid: internalShopGid,
        newTime,
      });
    } else {
      debouncedfetchShopOrderStatusDetails({ currentPage, newTime });
    }
  };

  const getShopOrders = (shopId) => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    debouncedfetchShopOrderStatusDetails({
      currentPage,
      shopGid: shopId,
      newTime,
    });
  };

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    if (orderDetails?.length > 0) {
      if (currentPage === 1) {
        setTableCount(totalPages);
      }
      console.log(totalPages, 'totalPagestotalPagestotalPagestotalPages');
      const lineItemsClose = orderDetails.filter((item) => item?.status === 'CLOSED');
      setPickupOrders(lineItemsClose);
      const lineItemsPrep = orderDetails.filter((item) => item?.status !== 'CLOSED');
      if (lineItemsPrep?.length > 1) {
        const middleIndex = Math.ceil(lineItemsPrep.length / 2);
        const chunkedArrays = [];
        for (let i = 0; i < orderDetails.length; i += middleIndex) {
          chunkedArrays.push(orderDetails.slice(i, i + middleIndex));
        }
        setPreparingOrders(chunkedArrays[0]);
        setPreparingOrder(chunkedArrays[1]);
      } else if (lineItemsPrep?.length === 1) {
        setPreparingOrders(lineItemsPrep);
      }
    }
    setPagination(existingElements => ({
      ...existingElements,
      total: Math.ceil(totalElements / 2),
      current: Number(currentPage),
      pageSize: 25,
      showTotal: total => `Total ${total} items`,
    }));
  }, [orderDetails]);

  const fetchShopAssociate = async (payload) => {
    try {
      const { data: { entity: { content } } } = await axiosAuthInstance.get(`shop-associate?email.EQ=${payload}`);
      if (content && content.length > 0) {
        getShopOrders(content[0].shop.gid);
      }
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response ? e.response.data.message : '',
      });
    }
  };

  useEffect(() => {
    if (firstTimeFetch) {
      fetchFullfillDetails('');
    }
    if ((kdsRole === ROLES.ASSOCIATE) && !shopGid) {
      const payloadEmail = email.replace(/\+/g, '%2B');
      fetchShopDetails(payloadEmail);
      fetchShopAssociate(payloadEmail);
      setFirstTimeFetch(false);
    }
    if (firstTimeFetch) {
      setFirstTimeFetch(false);
      fetchAllShopDetails('shops');
    } else {
      setFirstTimeFetch(false);
    }
    if ((kdsRole !== ROLES.ASSOCIATE)) {
      getData(location.search);
    }
  }, [location, shopGid, kdsRole]);

  useEffect(() => {
    if (!validator) {
      getData(location.search);
    }
  }, [validator]);

  useEffect(() => {
    if (messageRecevied === true) {
      setMessageRecevied(false);
      getData(location.search);
    }
  }, [messageRecevied]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     const newCount = count - 1;
  //     if (newCount > 0) {
  //       setCount(newCount);
  //     }
  //     if (newCount === 0) {
  //       getData(location.search);
  //       setCount(60);
  //       setInitialLoad(false);
  //     }
  //   }, 1000);
  // }, [count]);

  useEffect(() => {
    setTimeout(() => {
      const newCount = tableCount - 1;
      if (newCount > 0) {
        history.push({
          pathname: PAGES.ORDER_STATUS,
          search: `?pageNum=${totalPages - newCount}`,
        });
        setTableCount(newCount);
      }
      if (newCount === 0) {
        setTableCount(totalPages);
        history.push({
          pathname: PAGES.ORDER_STATUS,
          search: '',
        });
      }
    }, 90000);
  }, [tableCount]);

  const selectShop = (e) => {
    const gid = e[1];
    const selectedName = e[0];
    setInternalShopGid(gid);
    setShopName(selectedName);
    setShopGid(gid);
    setBannerText(e[3] ? e[3] : '');
    setShopImage(e[2] ? e[2] : null);
    if ((kdsRole === ROLES.ASSOCIATE)) {
      getShopOrders(gid);
    } else {
      history.push({
        pathname: PAGES.ORDER_STATUS_VIEW,
      });
    }
  };

  const generateDeviceId = () => {
    const navigatorInfo = navigator.userAgent;
    const timestamp = new Date().getTime();
    const randomValue = Math.random().toString(36).substring(7);
    return `${navigatorInfo}-${timestamp}-${randomValue}`;
  };

  useEffect(() => {
    if (role && role.name !== 'superuser') {
      getToken(messaging, {
        vapidKey:
          'BHc-PdMJkGh6Xc0pptrGU5QNJYyLNtFP4JylwMXXD_hkw1CLiFQmfEB-2_eZU3UboFjTdgIBAeSpWhu4k2wvY3k',
      })
        .then((currentToken) => {
          console.log(currentToken, 'fcmToken');
          if (currentToken) {
            localStorage.setItem('fcmToken', currentToken);
            const payload = {
              fcmToken: currentToken,
              platformType: 'WEB',
              type: 'KDS',
              deviceId: generateDeviceId(),
            };
            sendFcmToken(payload);
          } else {
            console.log(
              'No registration token available. Request permission to generate one.',
            );
          }
        })
        .catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        });

      onMessage(messaging, (payload) => {
        setMessageRecevied(true);
        const notificationMessage = payload && payload.data && payload.data.message;
        const jsonObject = JSON.parse(notificationMessage);
        const notificationBody = jsonObject && jsonObject.message;
        setNotification({
          type: NOTIFICATION.SUCCESS,
          payload: (notificationBody) || 'Order Updated',
        });
        // ...
      });
    }
  }, [messaging]);

  const handleTableChange = (page, sorter, filters) => {
    const parsed = queryString.parse(location.search);
    const filterParams = parsed.filterParams || '';
    const tempPage = page.current;
    let tempParams = '';
    if (filters.order === 'ascend') {
      tempParams = `&sortBy=${filters.field}&direction=ASC`;
    } else if (filters.order === 'descend') {
      tempParams = `&sortBy=${filters.field}&direction=DESC`;
    } else {
      tempParams = '';
    }
    if (location.search && filterParams) {
      const filterParam = encodeURIComponent(filterParams);
      history.push({
        pathname: PAGES.ORDER_STATUS,
        search: `?filterParams=${filterParam}&pageNum=${tempPage}${tempParams}`,
      });
    } else {
      history.push({
        pathname: PAGES.ORDER_STATUS,
        search: `?pageNum=${tempPage}${tempParams}`,
      });
    }
  };

  const readyColumns = [
    {
      title: 'Ready to Collect',
      dataIndex: 'name',
      width: '100%',
      align: 'left',
      render: (text, record) => {
        if (record?.estimatedOrderPickupTime && selectedAccount && selectedAccount.timezone) {
          const tzDate = moment
            .utc(record?.estimatedOrderPickupTime)
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
          const TyDate = moment
            .utc(new Date())
            .tz(selectedAccount.timezone)
            .format('MMM DD, YYYY, hh:mm a');
          const tempTzDate = new Date(tzDate).getTime();
          const tempTyDate = new Date(TyDate).getTime();
          const totalMinutes = (tempTzDate - tempTyDate) / (1000 * 60);
          const hours = Math.floor(totalMinutes / 60);
          const minutes = Math.floor(totalMinutes % 60);
          return (
            <Tooltip>
              <Row align="middle">
                <Col span={8}>
                  <p style={{ fontSize: '20px', fontWeight: '500', marginBottom: '0px' }}>
                    {record?.orderNumber || <>&#8211;</>}
                  </p>
                </Col>
                <Col span={16}>
                  <Row type="d-flex" justify="space-between" align="middle">
                    <Col span={24}>
                      <p style={{ fontSize: '20px', fontWeight: '500', marginBottom: '0px' }}>
                        {record?.customer?.name || <>&#8211;</>}&nbsp;
                        ( <img src={timerImg} alt="timer" /> &nbsp; {hours < 0 ? 0 : hours} : {minutes < 0 ? '00' : minutes} )
                      </p>
                    </Col>
                    {/* <Col span={6}>
                      <p style={{ fontSize: '18px', fontWeight: '500', marginBottom: '0px' }}>
                        <img src={timerImg} alt="timer" /> &nbsp; {hours < 0 ? 0 : hours} : {minutes < 0 ? '00' : minutes}
                      </p>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            </Tooltip>
          );
        }
        return (
          <Row align="middle">
            <Col span={12}>
              <p style={{
                fontSize: '18px',
                fontWeight: '500',
                marginBottom: '0px',
              }}
              >{record?.orderNumber || <>&#8211;</>}
              </p>
            </Col>
            <Col span={12}>
              <p style={{ fontSize: '18px', fontWeight: '500', marginBottom: '0px' }}>
                {record?.customer?.name || <>&#8211;</>}
              </p>
            </Col>
          </Row>
        );
      },
    },
  ];

  const columns = [
    {
      title: 'Preparing',
      dataIndex: 'name',
      width: '100%',
      align: 'left',
      render: (text, record) => (
        <Row align="middle">
          <Col span={8}>
            <p style={{
              fontSize: '20px', fontWeight: '500', marginBottom: '0px',
            }}
            >{record?.orderNumber || <>&#8211;</>}
            </p>
          </Col>
          <Col span={16}>
            <p style={{
              fontSize: '20px', fontWeight: '500', marginBottom: '0px',
            }}
            >
              {record?.customer?.name || <>&#8211;</>}
            </p>
          </Col>
        </Row>
      ),
    },
  ];

  const getCurrentTime = () => {
    const tzDate = moment
      .utc(new Date())
      .tz(selectedAccount?.timezone)
      .format('MMM DD, YYYY hh:mm a');
    return tzDate;
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div style={{
      display: 'flex', background: '#FFFFFF', flexDirection: 'column', minHeight: '100%',
    }}
    >
      <header style={{
        justifyContent: 'space-between',
        borderBottom: '0.5px solid #8E9CB2',
      }}
      >
        <Row type="flex" justify="space-between" align="middle">
          <Col>
            <SpText fontSize="20px" fontWeight="600">&nbsp;</SpText>
          </Col>
          <Col
            style={{
              marginRight: '5px',
              marginTop: '20px',
              marginBottom: '5px',
            }}
          >
            <Row
              type="flex"
            >
              {
                kdsRole === ROLES.ASSOCIATE ? (
                  <>
                    {
                      (shopData && shopData.length > 1) && (
                        <Col>
                          <Select
                            style={{
                              width: '350px',
                              marginRight: '5px',
                            }}
                            placeholder="select shop"
                            onSelect={(e) => selectShop(e)}
                            showSearch
                            defaultValue={shopName || 'Select shop'}
                          >
                            {shopData
                              .filter(item => !item.shop.deleted) // Filter out the deleted shops
                              .map(item => (
                                <Option
                                  key={item.shop.gid}
                                  value={[item.shop.name, item.shop.gid, item?.shop?.bannerText]}
                                >
                                  {!item.shop.deleted && item.shop.name}
                                </Option>
                              ))}
                          </Select>
                        </Col>
                      )
                    }
                  </>
                ) : (
                  <>
                    {
                      (shopsList && shopsList.length > 1) && (
                        <Col>
                          <Select
                            style={{
                              width: '350px',
                              marginRight: '5px',
                            }}
                            placeholder="select shop"
                            onSelect={(e) => selectShop(e)}
                            showSearch
                            defaultValue={shopName || 'Select shop'}
                          >
                            {
                              shopsList.map(item => (
                                <Option
                                  key={item.gid}
                                  value={[
                                    item?.name,
                                    item?.gid,
                                    item?.banner,
                                    item?.bannerText,
                                  ]}
                                >
                                  {item.name}
                                </Option>
                              ))
                            }
                          </Select>
                        </Col>
                      )
                    }
                  </>
                )
              }
              <Col>
                <button
                  type="submit"
                  style={{ cursor: 'pointer', border: 'none', background: 'transparent' }}
                  onClick={() => history.push(PAGES.ORDER_STATUS)}
                >
                  &nbsp;<ShrinkOutlined />
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </header>
      <Fullscreen isEnter={isEnter} onChange={setIsEnter}>
        <div style={{
          overflow: 'auto',
          flex: 1,
          padding: '20px',
          backgroundColor: '#fff',
        }}
        >
          <Row type="flex" justify="space-between" align="middle" style={{ backgroundColor: '#00045B', padding: '10px' }}>
            <Col>
              <SpText
                fontSize="20px"
                fontWeight="600"
                color="#fff"
              >
                {shopImage ? <img src={shopImage} alt="brand" width="100" /> : ''} {shopName || 'ALL SHOPS'}
              </SpText>
            </Col>
            <Col>
              <SpText fontSize="20px" fontWeight="600" color="#fff">{getCurrentTime()}</SpText>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ borderRight: '3px solid #D88615' }}>
              <Table
                rowClassName={(record, index) => (index % 2 === 0 ? 'table-light-pickup' : 'table-dark-process')}
                columns={columns}
                rowKey={(record) => record.gid}
                dataSource={preparingOrders}
                pagination={false}
                onChange={handleTableChange}
              />
            </Col>
            <Col span={8} style={{ borderRight: '3px solid #D88615' }}>
              <Table
                rowClassName={(record, index) => (index % 2 === 0 ? 'table-light-pickup' : 'table-dark-process')}
                columns={columns}
                rowKey={(record) => record.gid}
                dataSource={preparingOrder}
                pagination={pagination}
                onChange={handleTableChange}
              />
            </Col>
            <Col span={8}>
              <Table
                rowClassName={(record, index) => (index % 2 === 0 ? 'table-light-ready' : 'table-dark-readypick')}
                columns={readyColumns}
                rowKey={(record) => record.gid}
                dataSource={pickupOrders}
                pagination={false}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
          <div style={{ height: '100px' }}>
            &nbsp;
          </div>
          <div
            style={{
              position: 'fixed',
              width: '100%',
              bottom: '0',
              background: '#f7f7f7',
              textAlign: 'center',
              padding: '20px 0',
              boxShadow: '0 -5px 10px rgba(0, 0, 0, 0.2)',
              marginLeft: '-1.4%',
            }}
          >
            <img src={powered} alt="powered" style={{ marginLeft: isEnter ? '' : '-13%' }} />
          </div>
        </div>
      </Fullscreen>
    </div>
  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
  shopData: state.shopDetails.content,
  loading: state.loading.loading,
  selectedAccount: state.account.selectedAccount,
  role: (state.user.internalRole ? state.user.internalRole : state.user.role),
  orderDetails: state.shopDetails.orderStatusDetails.content,
  totalElements: state.shopDetails.orderStatusDetails.totalElements,
  totalPages: state.shopDetails.orderStatusDetails.totalPages,
  shopsList: state.shopDetails.shopsList.content,
  fullFillDetails: state.shopDetails.fullFillDetails.content,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  fetchShopDetails: (payload) => dispatch(shopDetailsActions.fetchShopDetails({
    payload,
  })),
  fetchShopOrderStatusDetails: (payload) => dispatch(shopDetailsActions.fetchShopOrderStatusDetails({
    payload,
  })),
  updateLineItems: (payload) => dispatch(shopDetailsActions.updateLineItems({
    payload,
  })),
  sendFcmToken: (payload) => dispatch(shopDetailsActions.sendFcmToken({
    payload,
  })),
  fetchAllShopDetails: (payload) => dispatch(shopDetailsActions.fetchAllShopDetails({
    payload,
  })),
  fetchFullfillDetails: (payload) => dispatch(shopDetailsActions.fetchFullfillDetails({
    payload,
  })),
  updateFullFill: (payload) => dispatch(shopDetailsActions.updateFullFill({
    payload,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(OrderStatusView);
